import EmployeeRegistrationForm from '../../../shared/components/employee/employee-registration-form'
import Layout from '../../../shared/components/ui/layout'
import Image from '../../../shared/assets/images/employeeRegistrationImage.svg'

const EmployeeRegistration = () => {
  return (
    <Layout Image={Image}>
      <EmployeeRegistrationForm />
    </Layout>
  )
}

export default EmployeeRegistration
